// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".showContainer--2GR5x2r- {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.showDescription--nVGP9uon {\n  font-size: 0.5em;\n  color: var(--color-normal-text);\n}\n\n.showValue--Q5zcP3D- {\n  font-size: 1.5em;\n  margin-bottom: 0.12em;\n}\n\n.mainContainer--euuRsEmZ {\n  display: flex;\n  justify-content: center;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showContainer": "showContainer--2GR5x2r-",
	"showDescription": "showDescription--nVGP9uon",
	"showValue": "showValue--Q5zcP3D-",
	"mainContainer": "mainContainer--euuRsEmZ"
};
export default ___CSS_LOADER_EXPORT___;
